import { useState } from 'react';
import { faqData } from '@/mocks/homeData';

export default function FAQ() {
  const [openIndex, setOpenIndex] = useState<number | null>(0);

  return (
    <section id="faq" className="w-full py-16 md:py-24 bg-background-50">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12 md:mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium mb-4">
            常见问题
          </span>
          <h2 className="font-heading text-3xl md:text-4xl font-bold text-foreground-900 mb-4">
            您可能关心的问题
          </h2>
          <p className="text-foreground-500 text-sm md:text-base">
            关于惠美梨的品种、购买、保存等常见疑问，这里都有答案
          </p>
        </div>

        <div className="flex flex-col gap-3">
          {faqData.map((faq, index) => (
            <div
              key={index}
              className="rounded-xl bg-background-100 overflow-hidden"
            >
              <button
                className="w-full flex items-center justify-between px-6 py-5 text-left cursor-pointer hover:bg-background-200/50 transition-colors"
                onClick={() => setOpenIndex(openIndex === index ? null : index)}
              >
                <h3 className="font-heading text-sm md:text-base font-semibold text-foreground-900 pr-4">
                  {faq.question}
                </h3>
                <div className={`w-6 h-6 flex items-center justify-center rounded-full transition-transform duration-300 flex-shrink-0 ${openIndex === index ? 'bg-primary-500 text-background-50 rotate-45' : 'bg-background-200 text-foreground-500'}`}>
                  <i className="ri-add-line text-sm"></i>
                </div>
              </button>
              <div
                className={`overflow-hidden transition-all duration-300 ${
                  openIndex === index ? 'max-h-96 pb-5' : 'max-h-0'
                }`}
              >
                <div className="px-6 text-sm text-foreground-600 leading-relaxed">
                  {faq.answer}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}